export const translation = {
    underConstructionLabel: "Site under construction",
};
export default translation;
